/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShareholderRepresentation
 */
export interface ShareholderRepresentation {
    /**
     * 
     * @type {string}
     * @memberof ShareholderRepresentation
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof ShareholderRepresentation
     */
    number: number;
    /**
     * 
     * @type {string}
     * @memberof ShareholderRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ShareholderRepresentation
     */
    dataProviderKey: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShareholderRepresentation
     */
    generatorKeys: Array<string>;
}

/**
 * Check if a given object implements the ShareholderRepresentation interface.
 */
export function instanceOfShareholderRepresentation(value: object): value is ShareholderRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dataProviderKey' in value) || value['dataProviderKey'] === undefined) return false;
    if (!('generatorKeys' in value) || value['generatorKeys'] === undefined) return false;
    return true;
}

export function ShareholderRepresentationFromJSON(json: any): ShareholderRepresentation {
    return ShareholderRepresentationFromJSONTyped(json, false);
}

export function ShareholderRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareholderRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'number': json['number'],
        'name': json['name'],
        'dataProviderKey': json['dataProviderKey'],
        'generatorKeys': json['generatorKeys'],
    };
}

export function ShareholderRepresentationToJSON(json: any): ShareholderRepresentation {
    return ShareholderRepresentationToJSONTyped(json, false);
}

export function ShareholderRepresentationToJSONTyped(value?: ShareholderRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'number': value['number'],
        'name': value['name'],
        'dataProviderKey': value['dataProviderKey'],
        'generatorKeys': value['generatorKeys'],
    };
}

